/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Injectable } from '@angular/core';
import {
  DRAWING_ENGINE_TOOLS,
  HistoryService,
  LayersService,
  ObjectInfoTool,
  ObjectsPlacingService,
  ObjectsSourceService,
  PanZoomTool,
  SvgService,
  SvgTool,
} from '@bcl/drawing-control';

export const PreviewToolId = 'area-map-preview';
@Injectable()
export class PreviewTool extends SvgTool {
  public readonly id = PreviewToolId;
  public readonly icon = '';

  private panZoomTool: PanZoomTool;
  private objectInfoTool: ObjectInfoTool;

  constructor(
    engine: SvgService,
    historyService: HistoryService,
    layersService: LayersService,
    objectsSourceService: ObjectsSourceService,
    objectsPlacingService: ObjectsPlacingService
  ) {
    super(engine, historyService);
    this.panZoomTool = new PanZoomTool(<SvgService>engine, historyService);
    this.objectInfoTool = new ObjectInfoTool(
      engine,
      historyService,
      layersService,
      objectsSourceService,
      objectsPlacingService
    );
  }

  protected registerListeners(): void {
    this.panZoomTool.activate();
    this.objectInfoTool.activate();
  }

  protected removeListeners(): void {
    this.panZoomTool.deactivate();
    this.objectInfoTool.deactivate();
  }
}

export const previewToolProvider = {
  provide: DRAWING_ENGINE_TOOLS,
  useClass: PreviewTool,
  multi: true,
};
